import { render, staticRenderFns } from "./SelectCopySISS.vue?vue&type=template&id=2d11b361&"
import script from "./SelectCopySISS.vue?vue&type=script&lang=js&"
export * from "./SelectCopySISS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d11b361')) {
      api.createRecord('2d11b361', component.options)
    } else {
      api.reload('2d11b361', component.options)
    }
    module.hot.accept("./SelectCopySISS.vue?vue&type=template&id=2d11b361&", function () {
      api.rerender('2d11b361', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/managementTray/informationFlow/copies/SelectCopySISS.vue"
export default component.exports